import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import ButtonBase from '@material-ui/core/ButtonBase';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Mixpanel from 'utils/mixpanelService';

const useStyles = makeStyles(theme => ({
  wrapper: {
    width: props => props.width || '100%',
    '& > *:first-child': {
      marginTop: 0,
    },
    [theme.breakpoints.up('1140')]: {
      marginLeft: 24,
      marginRight: 24,
    },
    [theme.breakpoints.down('1140')]: {
      marginLeft: 40,
      marginRight: 40,
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: 32,
      marginRight: 32,
    },
    [theme.breakpoints.down('xs')]: {
      width: '100% !important',
      paddingTop: 60,
    },
  },
  title: {
    color: props => props.color || '#fff',
    lineHeight: '1.35',
    fontSize: 37,
    fontFamily: theme.typography.homeHeroHeaderFont,
    fontWeight: 700,
    display: '-webkit-box',
    margin: '0 auto',
    '-webkit-line-clamp': '3',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'keep-all',
    [theme.breakpoints.down('sm')]: {
      fontSize: 28,
    },
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
    },
  },
  subTitle: {
    color: props => props.color || '#fff',
    marginTop: 8,
    fontSize: 17,
    lineHeight: '1.5',
    display: '-webkit-box',
    margin: '0 auto',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
    },
  },
  buttonWrapper: {
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
    },
  },
  button: {
    marginTop: 20,
    background: props => props.buttonBackground || '#01619B',
    padding: '8px 24px',
    borderRadius: '50vh',
    [theme.breakpoints.down('xs')]: {
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  buttonLabel: {
    fontSize: 18,
    color: props => props.buttonColor || '#fff',
    [theme.breakpoints.down('xs')]: {
      fontSize: 17,
    },
  },
}));

function Intro({ copy, slug }) {
  const history = useHistory();
  const classes = useStyles(copy.styles);
  const introTitle = _get(copy, 'header');
  const subTitle = _get(copy, 'callToAction');
  const buttonLabel = _get(copy, 'buttonLabel');
  const url = _get(copy, 'url');

  const handleClick = () => {
    history.push(url);

    Mixpanel.track('Home Hero - Button - Clicked', {
      slide: slug,
    });
  };
  return (
    <Grid item className={classes.wrapper}>
      <Grid container>
        {introTitle && (
          <Grid item xs={12}>
            <Typography className={classes.title}>{introTitle} </Typography>
          </Grid>
        )}
        {subTitle && (
          <Grid item xs={12}>
            <Typography className={classes.subTitle}>{subTitle} </Typography>
          </Grid>
        )}
        {buttonLabel && url && (
          <Grid item xs={12} className={classes.buttonWrapper}>
            <ButtonBase onClick={handleClick} className={classes.button}>
              <Typography className={classes.buttonLabel}>
                {buttonLabel}
              </Typography>
            </ButtonBase>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}

Intro.propTypes = {
  copy: PropTypes.object,
};

export default Intro;
